import { render, staticRenderFns } from "./NuevaSeccion.vue?vue&type=template&id=70be725a&"
import script from "./NuevaSeccion.vue?vue&type=script&lang=js&"
export * from "./NuevaSeccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports